'use client'

import {observer} from 'mobx-react'
import React from 'react'
import {useFormContext} from 'react-hook-form'

import {Location} from '@/src/(pages)/order/types'

import {useStore} from '@/src/shared/hooks/useStore'
import {FormAutoComplete} from '@/src/shared/ui/inputs/autocomplete'

import * as UI from './shipment-fields.styled'

export type ShipmentFieldsData = {
  address: Nullable<{
    city: Nullable<string>
    street: Nullable<string>
    house: Nullable<string>
    lobby: Nullable<string>
    housing: Nullable<string>
    building: Nullable<string>
    floor: Nullable<string>
    flat: Nullable<string>
    zip: Nullable<string>
  }>

  comment?: string
}

export interface Props {
  className?: string
}

export const ShipmentFields = observer((props: Props) => {

  return (
    <UI.Wrapper className={props.className}>
      <UI.FieldsRow>
        <CityInput />
        <UI.Input name="address.street" placeholder="Улица" />
      </UI.FieldsRow>

      <UI.FieldsRow>
        <UI.Input name="address.lobby" placeholder="Подъезд" />
        <UI.Input name="address.housing" placeholder="Корпус" />
        <UI.Input name="address.building" placeholder="Строение" />
      </UI.FieldsRow>
      <UI.FieldsRow>
        <UI.Input name="address.house" placeholder="Дом" />
        <UI.Input name="address.floor" placeholder="Этаж" />
        <UI.Input name="address.flat" placeholder="Кв/офис" />
        <UI.Input name="address.zip" placeholder="Индекс" />
      </UI.FieldsRow>
      {/*<UI.FieldsRow>*/}
      {/*<FormTextArea placeholder="Комментарий" name="comment"/>*/}
      {/*  <AntInput.TextArea*/}
      {/*    placeholder="Комментарий"*/}
      {/*    defaultValue={props.comment}*/}
      {/*    onChange={ev => props.onChange('comment', ev.target.value)}></AntInput.TextArea>*/}
      {/*</UI.FieldsRow>*/}
    </UI.Wrapper>
  )
})

const CityInput = observer(() => {
  const store = useStore<{locations: Location[]}>()
  const form = useFormContext<{address: {city: Id}}>()

  const city = form.watch('address.city')

  return (
    <FormAutoComplete
      classNames={{popup: {root: 'location-popup'}}}
      name="city"
      title="Город"
      placeholder="Город"
      defaultValue={
        store.pageData!.content.locations.find(location => location.value === city)?.label
      }
      options={store.pageData!.content.locations.map(location => ({
        ...location,
        key: location.value,
      }))}
      onSelect={(value, option) => {
        form.setValue('address.city', option.key, {shouldValidate: true, shouldTouch: true})
      }}
    />
  )
})
